var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('width:'+(200 + _vm.table_data.length*22)+'px; height:100%;'),attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }